import FCustomer from "@/models/f-customer";


export const customerModule = {
    namespace: true,
    state: {
        itemModifiedCust: new FCustomer(),
        formModeCust: String,
    },
    actions:{
        updateItemModifiedCust({commit}, payload) {
            commit('mutateItemModifiedCust', payload)
        },
        updateFormModeCust({commit}, payload){
            commit('mutateFormModeCust', payload)
        },
    },
    mutations:{
        mutateItemModifiedCust(state, payLoad) {
          state.itemModifiedCust = payLoad
        },
        mutateFormModeCust(state, payLoad){
            state.formModeCust = payLoad
        },
    }

}